"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpretEscapes = exports.word = exports.token = exports.whitespace = void 0;
const parsimmon_1 = __importDefault(require("parsimmon"));
exports.whitespace = parsimmon_1.default.regexp(/\s*/m);
function token(parser) {
    return parser.skip(exports.whitespace);
}
exports.token = token;
function word(str) {
    return parsimmon_1.default.string(str).thru(token);
}
exports.word = word;
function interpretEscapes(str) {
    let escapes = {
        b: '\b',
        f: '\f',
        n: '\n',
        r: '\r',
        t: '\t',
    };
    return str.replace(/\\(u[0-9a-fA-F]{4}|[^u])/, (_, escape) => {
        let type = escape.charAt(0);
        let hex = escape.slice(1);
        if (type === 'u') {
            return String.fromCharCode(parseInt(hex, 16));
        }
        if (escapes.hasOwnProperty(type)) {
            return escapes[type];
        }
        return type;
    });
}
exports.interpretEscapes = interpretEscapes;
